<template>
  <div
    class="row no-wrap text-black-1 items-center"
    data-automation="dark-mode"
  >
    <div
      class="row no-wrap items-center cursor-pointer"
      data-automation="dark-mode__light"
      @click="setDarkMode(false)"
    >
      <q-icon
        data-automation="dark-mode__light-icon"
        :name="`rvai-base:${isDark ? 'light--dark-theme' : 'light'}`"
        size="40px"
      />
      <span class="text-body-3 q-ml-sm">
        {{ $t('about.about.appearance.light') }}
      </span>
    </div>
    <div class="q-mx-md">
      <rv-toggle
        data-automation="dark-mode__toggle"
        :model-value="isDark"
        @update:model-value="setDarkMode"
      />
    </div>
    <div
      class="row no-wrap items-center cursor-pointer"
      data-automation="dark-mode__dark"
      @click="setDarkMode(true)"
    >
      <q-icon
        data-automation="dark-mode__dark-icon"
        :name="`rvai-base:${isDark ? 'dark--dark-theme' : 'dark'}`"
        size="40px"
      />
      <span class="text-body-3 q-ml-sm">
        {{ $t('about.about.appearance.dark') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDarkMode } from '@robovision/rvai-base'


const {
  isDark,
  set: setDarkMode,
} = useDarkMode()
</script>
